import React from 'react';
import { IVolumeSlider } from '../SliderFactory';
import VolumeSlider from './SliderWithControlButton';

function SliderWithControlButtonSideRight(
    others: IVolumeSlider
): React.ReactElement {
    return (
        <VolumeSlider
            thumbImgSrc={`/resources/speechComfort/slider-right.svg`}
            {...others}
        />
    );
}

export default SliderWithControlButtonSideRight;
